module.exports={
    "rollback": {
        "title": "Oups!",
        "message": "Vous avez donné la même réponse à toutes les questions, pour que le résultat soit valide, vous devez répondre de façon différente à au moins 1 question.",
        "continue": "Continuer"
    },
    "share": {
        "text_a": "J’ai répondu au questionnaire Ada-Intérêts et j’ai le profil",
        "text_b": ". Quel est le vôtre ?",
        "link": "https://ada.mesetudes.be",
        "general_share": {
            "link": "https://ada.mesetudes.be",
            "facebook": {
                "name": "Faites comme moi et répondez au questionnaire Ada-Intérêts !",
                "description": "C’est un outil d’exploration en ligne qui aide à déterminer quels programmes d’études correspondent à vos champs d’intérêt, vos traits de personnalité et vos aspirations professionnelles. De quoi trouver sa voie ! https://ada.mesetudes.be"
            },
            "twitter": "Pistez votre avenir avec Ada-Intérêts, un outil d'orientation en ligne ! https://ada.mesetudes.be",
            "email": {
                "subject": "Découvre Ada-Intérêts",
                "content": "Bonjour,\n\nJe t'invite à découvrir Ada-Intérêts, un outil d'exploration en ligne gratuit, qui te permettra d'identifier quelles professions correspondent à tes centres d’intérêt et ton vécu personnel et de repérer les programmes d'enseignement supérieur en lien avec ces professions.\n\nClique sur le lien suivant : https://ada.mesetudes.be !"
            }
        }
    },
    "pub": {
        "title": "Le saviez-vous?"
    },
    "feedback": {
        "invalid_email": "Courriel invalide",
        "no_msg": "Pas de message à envoyer",
        "invalid_input": "Une entrée n'est pas valide",
        "success": "Le message a été envoyé avec succès"
    },
    "question": {
        "do_you_agree": " ",
        "you_are": "",
        "not_agree": "pas d'accord",
        "agree": "entièrement <br>d'accord",
        "yes": "Oui",
        "no": "Non",
        "i_agree": " ",
        "needs_different_answer": "Veuillez entrer au moins une réponse différente des autres."
    },
    "global": {
        "title": "Ada-Intérêts",
        "subtitle": "Pistez votre avenir<br/>Construisez votre orientation",
	    "metatitle": "Ada-Intérêts, trouvez votre voie - un outil de l'ARES",
        "description": "Ada-Intérêts est un outil d’exploration en ligne qui aide à déterminer quels programmes d’études correspondent à vos champs d’intérêt, vos traits de personnalité et vos aspirations professionnelles. De quoi trouver sa voie !",
        "menu_bar": {
            "left_label": "menu",
            "right_label": "Mon compte<br/>Mes résultats"
        },
        "steps": [
            {
                "n": "1",
                "text": "Domaines"
            },
            {
                "n": "2",
                "text": "Familles"
            },
            {
                "n": "3",
                "text": "Professions et&nbsp;formations"
            }
        ],
        "udem_link": "http://www.umontreal.ca/"
    },
    "loading": {
        "text": "Veuillez patienter&hellip;"
    },
    "menu": {
        "title": "Mes résultats",
        "hi": "Bonjour",
        "high_score": "Votre meilleur score",
        "follow_scores": "Vous pouvez suivre ici les résultats de votre questionnaire Ada-Intérêts pour chaque domaine et chaque famille.",
        "no_result": {
            "title": "Vous n'avez pas encore déterminé vos familles pour ce domaine",
            "cta": "explorer les familles de ce domaine"
        }
    },
    "home": {
        "btn_begin_label": "Commencer le questionnaire (en mode déconnecté)",
        "btn_login_label": "Se connecter ou créer un compte",
        "btn_new_label": "Commencer un nouveau questionnaire",
        "btn_resume_label": "Poursuivre mon questionnaire",
        "btn_new_label_notlogged": "Commencer un nouveau questionnaire (en mode déconnecté)",
        "btn_resume_label_notlogged": "Poursuivre mon questionnaire (en mode déconnecté)",
        "btn_loggedin_begin_label": "Commencer le questionnaire (en mode connecté)",
        "description": "Je souhaite obtenir <a href=\"https://www.mesetudes.be/ada\" target=\"_blank\" class=\"ahover\">plus d’explications sur le projet ADA</a>",
        "presentation": {
            "title": "Ada-Intérêts est un outil d’aide à l’orientation qui vous permettra :",
            "point_a": "d’identifier les domaines et les familles d’activités professionnelles liées à votre vécu personnel,",
            "point_b": "d’explorer les professions de ces domaines et familles d’activités,",
            "point_c": "de repérer les programmes d’enseignement supérieur en lien avec ces professions.",
            "texte": "Ada-Intérêts est accessible en ligne, gratuitement et s'adresse",
            "texte_a": "aux élèves en fin d’enseignement secondaire (4<sup>e</sup>-5<sup>e</sup>-6<sup>e</sup> années)",
            "texte_b": "aux étudiants en cours d’études supérieures"
        },
        "login_lnk": "/users/identification",
        "create_account_lnk": "/users/identification"
    },
    "domains": [
        {
            "id": "1",
            "nom": "L'humain",
            "letter": "H",
            "prc": "0",
            "slug": "humain"
        },
        {
            "id": "2",
            "nom": "La Gestion",
            "letter": "G",
            "prc": "0",
            "slug": "gestion"
        },
        {
            "id": "3",
            "nom": "Le vivant",
            "letter": "V",
            "prc": "0",
            "slug": "vivant"
        },
        {
            "id": "4",
            "nom": "La matière",
            "letter": "M",
            "prc": "0",
            "slug": "matiere"
        },
        {
            "id": "5",
            "nom": "La culture",
            "letter": "C",
            "prc": "0",
            "slug": "culture"
        }
    ],
    "footer": {
        "credits": "<strong style=\"font-size: 115%;\">Le projet ADA est issu d'un partenariat entre l'<a href=\"https://www.ares-ac.be\" target=\"_blank\">ARES</a> et l'<a href=\"https://www.mesetudes.be/enseignement-superieur/institutions/poles-academiques\" target=\"_blank\">ensemble des Pôles académiques</a>, avec le soutien de la <a href=\"https://www.federation-wallonie-bruxelles.be/\" target=\"_blank\">Fédération Wallonie-Bruxelles</a>.</strong><br/><br/>Ada-Intérêts est un outil d'orientation basé sur la Méthode Cursus (Yves Maurais, auteur chez Septembre Editeur, Québec), initialement adaptée à la Belgique francophone par le <a href=\"https://polelouvain.be/\" target=\"_blank\">Pôle Louvain</a> et le <a href=\"https://uclouvain.be/fr/etudier/cio/\" target=\"_blank\">CIO</a>. Les données <i>Formations</i> et <i>Métiers</i> sont produites et fournies par l'<a href=\"https://mesetudes.be\" target=\"_blank\">ARES</a> et le <a href=\"https://www.leforem.be/\" target=\"_blank\">Forem</a>.<br/>Développement informatique: <a href=\"https://admission.umontreal.ca/cursus/\" target=\"_blank\">Université de Montréal</a> et <a href=\"https://www.argon7.be/\" target=\"_blank\">Argon7 Services srl</a>.<br/><a href=\"https://form.ares-ac.be/contact-ada\" target=\"_blank\">Contactez-nous</a>.",
    },
    "instructions": {
        "caution": "Attention !",
        "advices": "Quelques conseils avant de commencer le questionnaire",
        "advice_a": "Prévoyez de 10 à 15 minutes",
        "advice_b": "Choisissez un endroit calme",
        "advice_c": "Répondez aux questions sur base de vos centres d'intérêt, de vos expériences personnelles et de votre vécu scolaire.",
        "advice_d": "Ne passez pas trop de temps sur une question. Soyez spontané.",
        "advice_e": "Demandez à un proche de répondre au questionnaire pour vous et comparez les résultats.",
        "advice_f": "Pour poursuivre votre démarche d'orientation, prenez rendez-vous avec un professionnel de l'orientation <ul> <li>dans les services d'information et d'orientation des établissements d'enseignement supérieur: <ul> <li><a href=\"https://www.poleacabruxelles.be\" target=\"_blank\">Pôle académique de Bruxelles</a></li> <li><a href=\"https://www.polehainuyer.be/\" target=\"_blank\">Pôle académique du Hainaut</a></li> <li><a href=\"https://poleliegelux.be/\" target=\"_blank\">Pôle académique de Liège-Luxembourg</a></li> <li><a href=\"https://polelouvain.be/\" target=\"_blank\">Pôle académique de Louvain</a></li> <li><a href=\"https://www.poledenamur.be/\" target=\"_blank\">Pôle académique de Namur</a><br/>&nbsp;</li> </ul> </li> <li>dans les <a href=\"https://monorientation.be/je-prepare-mon-orientation/jen-discute\" target=\"_blank\">organismes d'information et de conseil en orientation en Wallonie et à Bruxelles</a>: Centres PMS, Centres Infor-Jeunes, Cités des Métiers, Services d'Actions en Milieu Ouvert (AMO), Centre SIEP, ...  </li> </ul>",
        "continue": "Continuer",
        "popup": {
            "title": "Guide de navigation",
            "browse_steps": "Naviguer à travers les étapes",
            "view_results": "Consultez vos résultats",
            "continue": "Continuer"
        }
    },
    "profile": {
        "domains_title": "Les domaines d’intérêt",
        "footnote": "Nous vous invitons à explorer tous les domaines qui affichent plus de 60%. Vous pouvez à tout instant changer de domaine à l'aide du menu \"Mes résultats\" en haut à droite ou en cliquant sur les menus de couleurs ci-dessus.",
        "footnote2": "Si vous n'avez que des résultats en dessous de 60%, nous vous invitons à lire les descriptions des domaines et à explorer celui qui vous semble vous correspondre le plus.",
        "domain": {
            "what_is": "Qu'est-ce que",
            "linked_families": "Les familles liées au domaine de",
            "explore_families": "Continuez le questionnaire"
        }
    },
    "family": {
        "results_by_family": "Résultats par famille",
        "explore": "Explorer un autre domaine",
        "footnote" : "<strong>Vous êtes surpris par les résultats ?</strong><br/>Nous vous invitons à explorer les autres domaines et familles dont les scores sont élevés dans votre cas.<br/><br/><details><summary>Comment? <span>3 possibilités&hellip;</span></summary><ol><li>cliquer sur les menus de couleur ci-dessus (autres familles du même domaine)</li><li>explorer les familles d’un autre domaine avec le menu \"Mes résultats\" en haut à droite</li><li>utiliser les flèches \"Retour aux domaines\" ou \"Prochaine famille\" en bas de la page</li></ol></details><br/><strong>Toujours perdu après avoir consulté plusieurs familles ?</strong><br/>Prenez rendez-vous avec un·e professionnel·le de l’orientation après avoir <a href=\"/print.php\" target=\"cursusprint\">imprimé les domaines et les familles</a> qu'Ada-intérêts vous a conseillés.<br/><br/><details><summary><span>Où prendre rendez-vous ?</span></summary><ul><li>dans les services d'information et d'orientation des établissements d'enseignement supérieur: <ul> <li><a href=\"https://www.poleacabruxelles.be\" target=\"_blank\">Pôle académique de Bruxelles</a></li> <li><a href=\"https://www.polehainuyer.be/\" target=\"_blank\">Pôle académique du Hainaut</a></li> <li><a href=\"https://poleliegelux.be/\" target=\"_blank\">Pôle académique de Liège-Luxembourg</a></li> <li><a href=\"https://polelouvain.be/\" target=\"_blank\">Pôle académique de Louvain</a></li> <li><a href=\"https://www.poledenamur.be/\" target=\"_blank\">Pôle académique de Namur</a><br/>&nbsp;</li> </ul> </li> <li>dans les <a href=\"https://monorientation.be/je-prepare-mon-orientation/jen-discute\" target=\"_blank\">organismes d'information et de conseil en orientation en Wallonie et à Bruxelles</a>: Centres PMS, Centres Infor-Jeunes, Cités des Métiers, Services d'Actions en Milieu Ouvert (AMO), Centre SIEP, ...  </li></ul></details>",
        "learn_more": "En savoir plus sur",
        "they_do": "Les professionnel·le·s de cette famille s'activent à :",
        "they_are": "Ils sont :",
        "they_love": "Ils aiment :",
        "they_have": "Ils ont :",
        "they_prioritize": "Ils privilégient :",
        "they_work": "Ils travaillent principalement pour des :",
        "share_cta": "PARTAGER",
		"share_popup": {
			"title": "Le questionnaire Ada-intérêts vous a aidé?",
			"text": "Invitez vos amis Facebook à répondre au questionnaire",
			"cta": "Partagez vos résultats"
		},
        "programs": {
            "title": "Formations supérieures organisées en Fédération Wallonie-Bruxelles en lien avec la famille",
            "intro": "<strong>Bon à savoir</strong><details><summary>Les formations reprises ici sont de <strong>niveau supérieur</strong> (post-secondaire). Ada-intérêts ne renseigne pas les formations <span>telles que&hellip;</span></summary><ul><li>l'enseignement <strong>secondaire</strong>: voir le portail <a href=\"https://monorientation.be\" target=\"_blank\">monorientation.be</a></li><li>l'enseignement en <strong>alternance</strong>: <a href=\"http://www.ifapme.be\" target=\"_blank\">IFAPME</a> (Région wallonne) et <a href=\"http://www.sfpme.spfb.brussels\" target=\"_blank\">SFPME</a> (Bruxelles)</li><li>les filières <strong>professionnelles</strong>: <a href=\"https://www.mil.be/fr/\" target=\"_blank\">Défense</a>, <a href=\"https://www.jobpol.be/fr\" target=\"_blank\">Police</a>, &hellip;</li></ul></details>",
            "intro2": "Si vous êtes en fin du secondaire ou en bachelier, cliquer sur « Formations supérieures initiales »<br/>Si vous êtes (futur·e) jeune diplômé·e, cliquer sur « Formations supérieures complémentaires » et sur « Formations supérieures non diplômantes »<br/><br/>Sélectionnez les formations pour lesquelles vous souhaiteriez plus de précisions.<br/><br/><strong>Un conseil</strong><br/>Passez en revue l’ensemble des formations proposées.  Soyez curieux.  Ne vous limitez pas à celles que vous connaissez déjà.",
            "first_cycle": "Programmes d'études au 1<sup>er</sup> cycle",
            "superior_cycle": "Programmes d'études au cycles supérieurs",
            "credits": "crédits"
        },
        "work": {
            "title": "Exemples de professions en lien avec la famille",
            "intro": "<strong>Un conseil ! </strong><br/>Ne vous limitez pas aux professions que vous connaissez déjà, soyez curieux, vérifiez si vous vous retrouvez dans une majorité de métiers renseignés&hellip; Si ce n’est pas le cas, il sera sans doute nécessaire d’explorer une autre famille.",
            "intro2": "Cliquez sur <span class=\"icn-ajouter\"></span> pour marquer vos préférences de profession: <span class=\"bticn-heart-2\"></span> = moyen ou <span class=\"bticn-heart-1\"></span> = fort (re-cliquez sur l'icône pour changer votre préférence). Les professions marquées appara&icirc;tront alors sur le tableau imprimable (onglet \"Mes résultats\" en haut à droite)."
        },
        "back_to_domains": "Retour aux domaines",
        "next": "Prochaine famille"
    }
}
